import React from 'react';
import { Page } from '../types';

interface FooterProps {
    setCurrentPage: (page: Page) => void;
}

const Footer: React.FC<FooterProps> = ({ setCurrentPage }) => {
  return (
    <footer className="bg-white dark:bg-black border-t border-slate-200 dark:border-zinc-800">
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
             <div className="flex items-center space-x-2">
               <span className="text-2xl font-bold text-slate-800 dark:text-zinc-100">Wampia<span className="text-[#05F564]">.</span></span>
            </div>
            <p className="mt-4 text-slate-500 dark:text-zinc-400 text-sm">
              AI-Powered WhatsApp agents to revolutionize your business communication.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-800 dark:text-zinc-200 tracking-wider uppercase">Navigate</h3>
            <ul className="mt-4 space-y-2">
                <li><button onClick={() => setCurrentPage(Page.Home)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Home</button></li>
                <li><button onClick={() => setCurrentPage(Page.Pricing)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Pricing</button></li>
                <li><button onClick={() => setCurrentPage(Page.UseCases)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Use Cases</button></li>
                <li><button onClick={() => setCurrentPage(Page.About)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">About Us</button></li>
                <li><button onClick={() => setCurrentPage(Page.Contact)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Contact</button></li>
            </ul>
          </div>
           <div>
            <h3 className="text-sm font-semibold text-slate-800 dark:text-zinc-200 tracking-wider uppercase">Legal</h3>
            <ul className="mt-4 space-y-2">
                <li><button onClick={() => setCurrentPage(Page.PrivacyPolicy)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Privacy Policy</button></li>
                <li><button onClick={() => setCurrentPage(Page.TermsOfService)} className="text-base text-slate-500 dark:text-zinc-400 hover:text-[#05F564] transition-colors">Terms of Service</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-800 dark:text-zinc-200 tracking-wider uppercase">Connect</h3>
            <div className="flex mt-4 space-x-6">
              {/* Social media icons */}
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-slate-200 dark:border-zinc-800 pt-8 text-center text-sm text-slate-500 dark:text-zinc-400">
          <p>&copy; {new Date().getFullYear()} Wampia, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;